<template>
  <div class="performance-trend">
    <div class="performance-trend-header">近15日趋势</div>
    <div class="performance-trend-diagram">
      <CChart :options="chartOptions" :height="300" />
    </div>
  </div>
</template>

<script>
import CChart from "../common/CChart.vue";
import { USER_ROLES } from "@/consts";
import { getRMTrendReportByDay, getSMTrendReportByDay } from "@/api";
export default {
  components: { CChart },
  props: {
    role: String,
  },
  data() {
    return {
      chartOptions: null,
    };
  },
  watch: {
    role: {
      handler(role) {
        // console.log("role", role);
        if (role) {
          if (role === USER_ROLES.STORE_MANAGER) {
            const storeId = this.$store.getters.currentStore?.storeId;
            if (storeId) {
              this.api = getSMTrendReportByDay.bind(null, storeId);
            } else return;
          } else {
            this.api = getRMTrendReportByDay;
          }
          this.getData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getData() {
      try {
        const res = await this.api();
        this.farmatChartOptions(res);
      } catch (error) {
        console.log("error", error);
      }
    },
    farmatChartOptions(data) {
      const categories = [
        { key: "salesAmount", label: "销售额", color: "#2db7f5" },
        { key: "salesCount", label: "销售量", color: "#ff6600" },
        { key: "orderCount", label: "订单量", color: "#808bc6" },
      ];
      // console.log(this.$moment().set("date", 30).set("month", 1));
      const keys = Object.keys(data)
        .map((key) => {
          // eslint-disable-next-line no-unused-vars
          const [_, m, d] = key.split("-").map((seg) => seg.replace(/^0/, ""));
          return {
            key,
            label: [m, d].join("."),
            value: this.$moment(key).valueOf(),
          };
        })
        .sort((a, b) => a.value - b.value);
      // .slice(0, 1);

      // 绘制图表
      this.chartOptions = {
        legend: {
          itemWidth: 18,
          itemHeight: 8,
          data: categories.map((cat) => cat.label),
          selected: {
            销售额: true,
            销售量: false,
            订单量: false,
          },
        },
        grid: {
          left: "6%",
          right: "6%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: keys.map(({ label }) => label),
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#CCCCCC", //左边线的颜色
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
            textStyle: {
              color: "#CCCCCC", //坐标值得具体的颜色
              fontSize: 8,
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#CCCCCC",
              width: "1",
            },
          },
          axisLabel: {
            inside: true,
            align: "left",

            textStyle: {
              color: "#CCCCCC", //坐标值得具体的颜色
              fontSize: 10,
            },
          },
          splitLine: {
            lineStyle: {
              color: "#F1F1F1",
            },
          },
        },
        series: categories.map((cat) => ({
          name: cat.label,
          type: "line",
          symbol: "emptyCircle",
          symbolSize: 6,
          itemStyle: {
            normal: {
              color: cat.color,
              lineStyle: {
                type: "solid",
                width: 1,
                color: cat.color,
              },
            },
          },
          data: keys.map(({ key }) => data[key][cat.key]),
        })),
      };
    },
  },
};
</script>

<style lang="less" scoped>
.performance-trend {
  margin-top: 5/20rem;
  margin-bottom: 5/20rem;
  background: #fff;

  box-sizing: border-box;

  &-header {
    height: 40/20rem;
    padding: 0 15/20rem;
    border-bottom: 1/20rem solid #f1f1f1;

    line-height: 40/20rem;
    font-weight: 500;
    font-size: 12/20rem;
    letter-spacing: 0;
    color: #333;
  }
  &-diagram {
    padding-top: 20/40rem;
  }
}
</style>
